import { tenantErrorFragment } from "@saleor/fragments/errors";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { TypedMutation } from "../mutations";
import {
  TenantInStoreCancelConfigUpdate,
  TenantInStoreCancelConfigUpdateVariables
} from "./types/InStoreCancelConfig";
import { tenantCreate, tenantCreateVariables } from "./types/tenantCreate";
import { tenantDelete, tenantDeleteVariables } from "./types/tenantDelete";
import {
  tenantFeaturedUpdate,
  tenantFeaturedUpdateVariables
} from "./types/tenantFeaturedUpdate";
import {
  tenantPromotionalRibbonUpdate,
  tenantPromotionalRibbonUpdateVariables
} from "./types/tenantPromotionalRibbonUpdate";
import { tenantUpdate, tenantUpdateVariables } from "./types/tenantUpdate";

export const tenantCreateMutation = gql`
  ${tenantErrorFragment}
  mutation tenantCreate($input: TenantCreateInput!) {
    tenantCreate(input: $input) {
      errors: tenantErrors {
        ...TenantErrorFragment
      }
      tenant {
        id
        storeId
        brand {
          id
          name
        }
        mall {
          id
          name
        }
        bannerImage {
          url
          alt
        }
        legalName
        unitNo
        code
        leaseNo
        contractId
        tenantType
        description
        location
        status
        operationStatus
        operationStartTime
        operationEndTime
        operationScheduleMeta
        dateCreated
        isExpressLongDistanceDeliveryAllowed
        isOtherBusiness
        ipay88SubMid
        isSameDayDeliveryAllowed
        tinNo
        completeAddress
        signatoryName
        signatoryEmail
        signatoryDesignation
        signatoryMobileNo
        bankName
        bankAccountName
        bankAccountNo
        financeName
        financeEmail
        financeMobileNo
        rentalType
        paymentFeeRate
        storeName
        tinNo
        isFeatured
        location
        cluster {
          id
          name
        }
        isUseTenantCluster
        subTenantType
      }
    }
  }
`;

export const TenantCreateMutation = TypedMutation<
  tenantCreate,
  tenantCreateVariables
>(tenantCreateMutation);

export const tenantUpdateMutation = gql`
  ${tenantErrorFragment}
  mutation tenantUpdate($id: ID!, $input: TenantUpdateInput!) {
    tenantUpdate(id: $id, input: $input) {
      errors: tenantErrors {
        ...TenantErrorFragment
      }
      tenant {
        id
        storeId
        brand {
          id
          name
        }
        mall {
          id
          name
        }
        legalName
        unitNo
        code
        leaseNo
        contractId
        tenantType
        description
        location
        status
        operationStatus
        operationStartTime
        operationEndTime
        operationScheduleMeta
        dateCreated
        isExpressLongDistanceDeliveryAllowed
        isOtherBusiness
        ipay88SubMid
        isSameDayDeliveryAllowed
        isStandardDeliveryEnabled
        isInStorePickupEnabled
        tinNo
        completeAddress
        signatoryName
        signatoryEmail
        signatoryDesignation
        signatoryMobileNo
        bankName
        bankAccountName
        bankAccountNo
        financeName
        financeEmail
        financeMobileNo
        rentalType
        paymentFeeRate
        storeName
        tinNo
        bannerImage {
          url
          alt
        }
        isFeatured
        cluster {
          id
          name
        }
        isUseTenantCluster
        subTenantType
      }
    }
  }
`;

export const TenantUpdateMutation = TypedMutation<
  tenantUpdate,
  tenantUpdateVariables
>(tenantUpdateMutation);

export const tenantPromotionalRibbonMutation = gql`
  ${tenantErrorFragment}
  mutation tenantPromotionalRibbonUpdate(
    $id: ID!
    $input: TenantPromotionalRibbonInput!
  ) {
    tenantPromotionalRibbonUpdate(id: $id, input: $input) {
      errors: tenantErrors {
        ...TenantErrorFragment
      }
      tenant {
        brand {
          id
          name
        }
        storeName
        promoRibbonDescription
        promoRibbonStart
        promoRibbonEnd
        isInStorePickupEnabled
        isStandardDeliveryEnabled
      }
    }
  }
`;

export const TenantPromotionalRibbonMutation = TypedMutation<
  tenantPromotionalRibbonUpdate,
  tenantPromotionalRibbonUpdateVariables
>(tenantPromotionalRibbonMutation);

export const tenantDeleteMutation = gql`
  ${tenantErrorFragment}
  mutation tenantDelete($id: ID!, $status: SmopStatusEnum!) {
    updateTenantStatus(id: $id, status: $status) {
      errors: tenantErrors {
        ...TenantErrorFragment
      }
      tenant {
        id
        storeId
        brand {
          id
          name
        }
        mall {
          id
          name
        }
        legalName
        unitNo
        code
        leaseNo
        contractId
        tenantType
        description
        status
        operationStatus
        operationStartTime
        operationEndTime
        operationScheduleMeta
        dateCreated
        isOtherBusiness
        tinNo
        completeAddress
        signatoryName
        signatoryEmail
        signatoryDesignation
        signatoryMobileNo
        bankName
        bankAccountName
        bankAccountNo
        financeName
        financeEmail
        financeMobileNo
        rentalType
        paymentFeeRate
        storeName
        bannerImage {
          url
          alt
        }
        cluster {
          id
          name
        }
      }
    }
  }
`;

export const TenantDeleteMutation = makeMutation<
  tenantDelete,
  tenantDeleteVariables
>(tenantDeleteMutation);

export const tenantFeaturedUpdateMutation = gql`
  ${tenantErrorFragment}
  mutation tenantFeaturedUpdate($id: ID!, $input: TenantUpdateInput!) {
    tenantUpdate(id: $id, input: $input) {
      errors: tenantErrors {
        ...TenantErrorFragment
      }
      tenant {
        id
        storeId
        brand {
          id
          name
        }
        mall {
          id
          name
        }
        legalName
        unitNo
        code
        leaseNo
        contractId
        tenantType
        description
        location
        status
        operationStatus
        operationStartTime
        operationEndTime
        operationScheduleMeta
        dateCreated
        isExpressLongDistanceDeliveryAllowed
        isOtherBusiness
        ipay88SubMid
        tinNo
        completeAddress
        signatoryName
        signatoryEmail
        signatoryDesignation
        signatoryMobileNo
        bankName
        bankAccountName
        bankAccountNo
        financeName
        financeEmail
        financeMobileNo
        rentalType
        paymentFeeRate
        storeName
        tinNo
        bannerImage {
          url
          alt
        }
        isFeatured
        subTenantType
      }
    }
  }
`;

export const useTenantFeaturedMutation = makeMutation<
  tenantFeaturedUpdate,
  tenantFeaturedUpdateVariables
>(tenantFeaturedUpdateMutation);

const TenantInStoreCancelConfigUpdateMutation = gql`
  mutation TenantInStoreCancelConfigUpdate(
    $input: UpdateInStoreCancelConfigInput!
  ) {
    updateTenantInStoreCancelConfig(input: $input) {
      config {
        id
        isEnabled
        cancellationDays
        allowNationwideDiscovery
      }
      inStoreCancelConfigErrors {
        field
        message
        code
      }
    }
  }
`;

export const useTenantInStoreCancelConfigMutation = makeMutation<
  TenantInStoreCancelConfigUpdate,
  TenantInStoreCancelConfigUpdateVariables
>(TenantInStoreCancelConfigUpdateMutation);
